module.exports = __webpack_public_path__ + "static/media/close-table.902e997c.svg";